exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#outer {\n    overflow: hidden;\n}\n#bottom {\n    display: none\n}\n#outer:hover #bottom {\n    display: block;\n    position: absolute;\n    left: 50;\n    top: 50;\n    border: 1px solid blue;\n    background-color: white;\n}\n", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/SideMenu/Promotion/DLSPromotion.vue"],"names":[],"mappings":";AACA;IACI,iBAAiB;CACpB;AACD;IACI,aAAa;CAChB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,wBAAwB;CAC3B","file":"DLSPromotion.vue","sourcesContent":["\n#outer {\n    overflow: hidden;\n}\n#bottom {\n    display: none\n}\n#outer:hover #bottom {\n    display: block;\n    position: absolute;\n    left: 50;\n    top: 50;\n    border: 1px solid blue;\n    background-color: white;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b5d9e60","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SideMenu/Promotion/DLSPromotion.vue
// module id = nrj3
// module chunks = 2